<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
            <div class="h-piece">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="年度">
                            <el-select filterable v-model="q.year"  placeholder="请选择">
                                <el-option
                                    v-for="(item) in qyearList"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="月度" class="h-elformWrap-2" prop="username">
                            <el-select filterable v-model="q.month" placeholder="请选择">
                                <el-option
                                    v-for="(item,index) in monthList"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="区域" prop="link">
                            <el-select v-model="q.areaName" clearable placeholder="请选择" style="width:100%">
                                <el-option v-for="item in quyuList"
                                           :key="item.code"
                                           :label="item.name"
                                           :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>

                    </div>
                </el-form>
                <!-- 展开搜素 -->

                <div class="l-screenBox">
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="selectChannelIndex">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                    </div>
                </div>
            </div>

            <!-- 结果展示 -->
            <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <!-- @selection-change="handleSelectionChange" -->
                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    :border="true"
                    max-height="560"
                    style="width: 100%"
                >
                    <el-table-column
                        label="序号"
                        type="index"
                        width="50px">
                    </el-table-column>
                    <el-table-column prop="areaName"  label="区域"  ></el-table-column>
                    <el-table-column prop="userName"  label="省区经理"   ></el-table-column>
                    <el-table-column prop="prodName"  label="链群"  ></el-table-column>
                    <el-table-column prop="targetAmount"  label="目标金额(万元)"  ></el-table-column>
                    <el-table-column prop="samePeriod" label="同期金额(万元)"   ></el-table-column>
                    <el-table-column prop="grabOrder" label="抢单金额(万元)"   ></el-table-column>
                    <el-table-column prop="completionRate" label="抢单完成率"   ></el-table-column>
                    <el-table-column prop="increase" label="增幅"   ></el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcelAll">批量导出
                            </el-button>
                        </div>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="selectPageAll"/>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>
<script>


import ss from "@/api/SystemService";
import xsptReport from "@/api/loud/xsptReport/xsptReport";
import updownfile from "@/utils/updownfile";

export default {
    data() {
        return {

            q: {
                areaName: "",
                year: "",
                month: "",
                targetDate:""
            },
            qyearList: [],
            quyuList:[],
            monthList: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
            tableData: [],
        }
    },

    methods: {
        //重置
        rest(){
            this.q= {
                area:"",
                usercode:"",
                username:"",
                year: "",
                month: "",

            }
        },

        getQuyuList() {
            ss.Dictservice.listbycategory("show_area").then(rd => {
                this.quyuList = rd;
            })
        },

        selectChannelIndex() {//
            this.q.targetDate =this.q.year+''+this.q.month;//年月

            ss.xsptReport.selectLianqunIndex(this.q).then(res => {
                console.log(res.obj)
                this.tableData = res.obj;
            })
        },

        exportExcelAll() {
            updownfile.down("/api/swyl/v1/demo/bscXsptTargetInt/downloadLianqunIndexExcel", this.q, "post", 'data');
        },
    },

    created() {
        var date = new Date();
        this.q.year = date.getFullYear();
        this.q.month =  (new Date().getMonth()+1<10?"0"+(new Date().getMonth()+1):(new Date().getMonth()+1));// 年月

        this.getQuyuList();

        this.selectChannelIndex();
        for (var i = 2021; i < new Date().getFullYear() + 2; i++) {
            this.qyearList.push(i);
        }
        if (this.$store.getters.hasRole('crm_quyu')) {
            this.qyFlag = true;
        }
    },

}

</script>
